import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createRoutine } from 'redux-saga-routines';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { checkTicketSaga } from './saga';
import {
  CheckTicketState,
  I_Ticket,
  I_PayloadGetTickets,
  I_Show,
  I_PayloadGetShows,
} from './types';
export const GET_LIST_PAYMENT_METHOD = createRoutine(
  'checkTicket/getListPaymentMethod',
);
export const GET_LIST_TICKET_FORM = createRoutine(
  'checkTicket/getTicketForm',
);
export const GET_TICKETS = createRoutine('checkTicket/getTickets');
export const RESET_NOT_FOUND = createRoutine('checkTicket/resetNotFound');
export const GET_SHOWS = createRoutine('checkTicket/getShows');
export const GET_DATA_AGENTS = createRoutine('checkTicket/getDataAgents');

export const initialState: CheckTicketState = {
  loading: false,
  error: false,
  success: false,
  listTicket: [],
  paginator: {},
  errorNotFound: null,
  listPaymentMethod: [],
  listShow: [],
  getListShowSuccess: false,
  listDataAgent: [],
  dataAgentpaginator: {}
};

const slice = createSlice({
  name: 'checkTicket',
  initialState,
  reducers: {
    resetStatusPage(state) {
      state.loading = initialState.loading;
      state.error = initialState.error;
      state.success = initialState.success;
    },
  },
  extraReducers: {
    /**
     * ! GET SHOWS
     */
    [GET_SHOWS.TRIGGER]: (state, action: PayloadAction<I_PayloadGetShows>) => {
      state.loading = true;
      state.success = false;
      state.error = false;
      state.getListShowSuccess = false;
    },
    [GET_SHOWS.SUCCESS]: (
      state,
      action: PayloadAction<{
        shows: I_Show[];
      }>,
    ) => {
      state.listShow = action.payload.shows;
      state.loading = false;
      state.getListShowSuccess = true;
      state.success = true;
      state.error = false;
    },
    [GET_SHOWS.FAILURE]: state => {
      state.loading = false;
      state.getListShowSuccess = false;
      state.success = false;
      state.error = true;
    },
    /**
     * ! GET TICKETS
     */
    [GET_TICKETS.TRIGGER]: (
      state,
      action: PayloadAction<I_PayloadGetTickets>,
    ) => {
      state.loading = true;
      state.success = false;
      state.error = false;
    },
    [GET_TICKETS.SUCCESS]: (
      state,
      action: PayloadAction<{
        tickets: any;
        paginator: any;
        maxFileReleaseTicket: any;
      }>,
    ) => {
      state.listTicket = action.payload.tickets;
      state.paginator = action.payload.paginator;
      state.maxFileReleaseTicket = action.payload.maxFileReleaseTicket;
      state.loading = false;
      state.success = true;
      state.error = false;
    },
    [GET_TICKETS.FAILURE]: state => {
      state.loading = false;
      state.success = false;
      state.error = true;
    },
    /**
     * ! GET DATA AGENTS
     */
    [GET_DATA_AGENTS.TRIGGER]: (
      state,
      action: PayloadAction<I_PayloadGetTickets>,
    ) => {
      state.loading = true;
      state.success = false;
      state.error = false;
    },
    [GET_DATA_AGENTS.SUCCESS]: (
      state,
      action: PayloadAction<{
        agents: any;
        paginator: any;
      }>,
    ) => {
      state.listDataAgent = action.payload.agents;
      state.dataAgentpaginator = action.payload.paginator;
      state.loading = false;
      state.success = true;
      state.error = false;
    },
    [GET_DATA_AGENTS.FAILURE]: state => {
      state.loading = false;
      state.success = false;
      state.error = true;
    },
    [RESET_NOT_FOUND]: (state, action) => {
      state.errorNotFound = null
      state.loading = false;
      state.success = false;
      state.error = true;
    }
  },
});

export const { actions: checkTicketActions } = slice;

export const useCheckTicketSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: checkTicketSaga });
  return { actions: slice.actions };
};
